import React from 'react';
import { ArrowRightIcon, LockIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  sub?: string | null;
  id?: string;
  className?: string;
};
export function CtaButton({
  label,
  sub = 'Instant Digital Access | One-Time Payment | 7-Day Guarantee',
  id,
  className = ''
}: CtaButtonProps) {
  return <div id={id} className={`flex w-full flex-col items-center ${className}`} data-id="element-28" data-mp="qkk6qtgfrazl">
      <a href={CHECKOUT_URL} className="inline-flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-brand px-5 py-5 text-center font-display text-[22px] font-extrabold uppercase leading-[1.05] tracking-wide text-ink shadow-[0_6px_0_#a16207] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-brand-hover active:translate-y-1 active:shadow-[0_2px_0_#a16207] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40 sm:text-[26px]" data-id="element-29" data-mp="qih67fhnpzgm">
        <span data-id="element-30" data-mp="35x5w9drqko1y">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-31" data-mp="35xxruolc2ls8" />
      </a>
      {sub && <p className="mt-4 flex items-start justify-center gap-1.5 text-center text-[13px] font-medium text-muted sm:text-sm" data-id="element-32" data-mp="39xzkk893c4vd">
          <LockIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-33" data-mp="3ew9g4jyq97hi" />
          <span data-id="element-34" data-mp="3jxyr5zly9l5l">{sub}</span>
        </p>}
    </div>;
}